import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0924a90d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "KnotQuestionViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "立体纽结理论", -1));
const _hoisted_3 = {
  class: "flex items-center"
};
const _hoisted_4 = {
  class: "ml12"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14 ml16 mr4"
}, "题目数量:", -1));
const _hoisted_6 = {
  class: "ft14",
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr"
}, "删除组", -1));
const _hoisted_8 = {
  class: "mr16"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "以下四个选项中哪一个绳索存在一个无法被解开的绳结。请选出它。", -1));
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14 ptr",
  style: {
    "color": "orangered"
  }
}, "删除", -1));
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        "group-title": "立体纽结理论分组",
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"]), _createVNode(_component_el_row, {
        class: "pd12"
      }, {
        default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
          "btn-id": 21,
          "btn-name": "+ 新增分组",
          style: 1,
          size: "small",
          onFresh: $options.init
        }, null, 8, ["onFresh"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg flex items-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_ButtonDialog, {
            "btn-id": 22,
            "btn-name": "上传题目包",
            "init-data": {
              'groupId': $data.groupId
            },
            onFresh: $options.fetchList
          }, null, 8, ["init-data", "onFresh"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_ButtonDialog, {
            "btn-id": 34,
            "btn-name": "上传单个题目",
            "init-data": {
              'groupId': $data.groupId
            },
            onFresh: $options.fetchList
          }, null, 8, ["init-data", "onFresh"])]), _hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($data.questions.length), 1)])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [$data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "组内的题目也会一起删除，确定吗",
            onConfirm: $options.deleteGroup
          }, {
            reference: _withCtx(() => [_hoisted_7]),
            _: 1
          }, 8, ["onConfirm"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: q.id,
          class: "wbg mt12",
          style: {
            "border": "#1388ff 1px dashed"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            class: "flex flex-col flex items-center justify-center pd12"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "ft14"
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_8, "第" + _toDisplayString(qi + 1) + "题 ", 1)]),
              _: 2
            }, 1024), _hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(q.questionImages), (img, imgIndex) => {
              return _openBlock(), _createElementBlock("img", {
                key: `img_op_${q.id}_${imgIndex}`,
                style: {
                  "max-width": "100%"
                },
                src: img
              }, null, 8, _hoisted_10);
            }), 128))]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 12,
            class: "flex flex-col colCenter ft14"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "flex items-center justify-center wd100 pd12"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 4,
                class: "flex items-center justify-center"
              }, {
                default: _withCtx(() => [_hoisted_11]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 16,
                class: "flex items-center justify-center"
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, "第" + _toDisplayString(qi + 1) + "题 答案：" + _toDisplayString(q.rightAnswer), 1)]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                span: 4,
                class: "flex justify-end items-center"
              }, {
                default: _withCtx(() => [$data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 0,
                  title: "确定删除吗",
                  onConfirm: $event => $options.deleteKnotQuestion(q.id)
                }, {
                  reference: _withCtx(() => [_hoisted_12]),
                  _: 2
                }, 1032, ["onConfirm"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(q.analysisImages), (img, imgIndex) => {
              return _openBlock(), _createElementBlock("img", {
                key: `img_aw_${q.id}_${imgIndex}`,
                style: {
                  "max-width": "100%"
                },
                src: img
              }, null, 8, _hoisted_13);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })]);
}